import { MutableRefObject } from 'react';

export function resetScrollFor(ref: MutableRefObject<any>): void {
  if (ref.current) {
    ref.current.scrollTop = 0;
  }
}
